import { instanceOf } from "./instanceOf";

function castAs<T>(instance: any, type: string): T | null {
  return instanceOf(instance, type) ? instance as T : null;
}

export { castAs };
